import React, { useState, useEffect } from "react";
import "./taskparticipated.scss";
import Pagination from "react-bootstrap/Pagination";
import { Accordion, Modal } from "react-bootstrap";
import Navbar from "../landing/header/Navbar";
import axios from "axios";
import { API_URL } from "../../utils/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import ReactPaginate from "react-paginate";
import Loader from "../../hooks/loader";
import RedeemTask from "../../hooks/write/redeemTask";
import RedeemTask1 from "../../hooks/write/redeemTask1";
import { Link } from "react-router-dom";
import ClaimRow from "./ClaimRow";
import Environment from "../../utils/Environment";

import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import TaskStatus from "./TaskStatus";
import ParticipatedTimer from "./ParticipatedTimer";
import ClaimRowMobile from "./ClaimRowMobile";
import { updateTaskStatus } from "../../services/statusCompleted";
import ConditionalLink from "../../helper/Components/ConditionalLink";
import CustomToast from '../../components/CustomToast';
import { intitial_production_eth_id } from "../../constants/id";




const Taskparticipated = () => {
  const { redeemTask1 } = RedeemTask1();
  const { redeemTask } = RedeemTask();
  const [show4, setShow4] = useState(false);
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);
  const [show5, setShow5] = useState(false);
  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);

  const [show6, setShow6] = useState(false);
  const handleClose6 = () => setShow6(false);
  const handleShow6 = () => setShow6(true);

  const [loader, setLoader] = useState(false);
  const [pages, setPages] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [arry, setArry] = useState([]);
  const [winnerData, setWinnerData] = useState([]);
  const [creater, setCreat] = useState(null);
  const [selectedIs, setSelectedIs] = useState(null);
  const [dataaa, setdatata] = useState(null);
  // console.log(dataaa?.task?.id, 'dataaadataaadataaa')
  const handlePageChange = (e) => {
    // console.log("called");
    const selectedPage = e.selected;
    setPage(selectedPage);
  };
  const getProfile = async () => {
    setLoader(true);
    let accessToken = localStorage.getItem("accessToken");
    var config = {
      method: "get",
      url: `${API_URL}participants/my?limit=${5}&offset=${page + 1}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Include the access token here
      },
    };
    try {
      let response = await axios(config);

      if (response) {
        let vale = response?.data?.data;
        // console.log('Task created successfully:', response.data.data);
        setPageCount(vale?.count / 5);
        setPages(vale?.pages);
        setArry(vale?.participations);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error occurred while creating task:", error);
      setLoader(false);
      // toast.error(error?.message);
    }
  };
  useEffect(() => {
    getProfile();
  }, [page]);

  const claimToken = async () => {
    let sign = localStorage.getItem("sign");
    // // console.log(winnerData?.task, 'sddsadasasd');\
    // console.log(creater, sign, 'signsignsign');
    setLoader(true);
    try {
      let value = await redeemTask(creater, sign);
      if (value) {
        await updateTaskStatus(dataaa?.task?.id)
        handleShow5();
        handleClose4();
        aditProfile();
        setLoader(false);
      }
    } catch (err) {
      // console.log(err, "contract erro");
      setLoader(false);
      // toast.error("Something went wrong!");
       CustomToast.show('error', 'Error!', 'Something went wrong!')

    }
  };
  const claimToken1 = async () => {
    let sign = localStorage.getItem("sign");
    // // console.log(winnerData?.task, 'sddsadasasd');\
    // console.log(creater, sign, 'signsignsign');
    setLoader(true);
    try {
      let value = await redeemTask1(creater);
      if (value) {
        await updateTaskStatus(dataaa?.task?.id)
        handleShow5();
        handleClose6();
        aditProfile();
        setLoader(false);
      }
    } catch (err) {
      // console.log(err, "contract erro");
      setLoader(false);
      // toast.error("Something went wrong!");
      CustomToast.show('error', 'Error!', 'Something went wrong!')
    }
  };
  const aditProfile = async () => {
    let accessToken = localStorage.getItem("accessToken");
    setLoader(true);
    var config = {
      method: "patch",
      url: `${API_URL}participants/${selectedIs}/claim-reward`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Include the access token here
      },
      data: {
        isClaimed: true,
      },
    };
    try {
      let response = await axios(config);

      if (response) {
        getProfile();
        setLoader(false);
      }
    } catch (error) {
      console.error("Error occurred while creating task:", error);
      setLoader(false);
      // toast.error(error.message);
      CustomToast.show('error', 'Error!', error.message)
    }
  };
  const apiCallHandler = async (e) => {
    setdatata(e);
    setLoader(true);
    setSelectedIs(e?.id);
    let accessToken = localStorage.getItem("accessToken");
    let signg = localStorage.getItem("sign");
    var config = {
      method: "get",
      url: `${API_URL}tasks/${e?.task?.id}/signature`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Include the access token here
      },
    };
    try {
      let response = await axios(config);

      if (response) {
        // console.log('Task created successfully:', response.data.data);
        handleShow4();
        setCreat(response?.data?.data);
        setLoader(false);
        //    setWinnerData(e)
      }
    } catch (error) {
      console.error("Error occurred while creating task:", error);
      setLoader(false);
    }
  };
  const apiCallHandler1 = async (e) => {
    setdatata(e);
    setLoader(true);
    setSelectedIs(e?.id);
    let accessToken = localStorage.getItem("accessToken");
    let signg = localStorage.getItem("sign");
    var config = {
      method: "get",
      url: `${API_URL}tasks/${e?.task?.id}/signature/dispute`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Include the access token here
      },
    };
    try {
      let response = await axios(config);

      if (response) {
        // console.log('Task created successfully:', response.data.data);
        handleShow6();
        setCreat(response?.data?.data);
        setLoader(false);
        //    setWinnerData(e)
      }
    } catch (error) {
      console.error("Error occurred while creating task:", error);
      setLoader(false);
    }
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip " className="tollmain" {...props}>
      You are selected as winner
    </Tooltip>
  );

  const renderTooltip1 = (props) => (
    <Tooltip id="button-tooltip " className="tolltipssss" {...props}>
      The task is active on the website and accepting participants. The due date
      has not yet passed.
    </Tooltip>
  );
  return (
    <>
      {loader && <Loader />}
      {/* <Navbar /> */}
      <section className="taskscreated">
        <img
          src="/assets/importantassets/backshade.png"
          alt="backshade"
          className="backshade"
        />
        <img
          src="/assets/importantassets/backshadembl.png"
          alt="backshade"
          className="backshadembl d-none"
        />
        <div className="custom-container">
          <p className="toppara">
            <span className="light">Home </span>/ Tasks I Participated in
          </p>
          <h2 className="createdhead">Tasks I Participated in</h2>
          <div className="createdtasktable">
            {arry.length > 0 ? (
              <table>
                <thead>
                  <th></th>
                  <th>Task Name</th>
                  <th>Reward</th>
                  <th>Transaction Hash</th>
                  {/* <th>Dispute Period</th> */}
                  {/* <th>Voting Period</th> */}
                  <th>Created By</th>
                  <th>Status</th>
                  <th>Ends in</th>
                  <th>Action</th>
                </thead>
                <tbody>
                  {arry?.map((e, id) => {

                    const currentEpochSeconds1 = Math.floor(Date.now() / 1000);
                    const date1 = new Date(e?.task?.coolDownPeriod);
                    const epochSeconds1 = Math.floor(date1?.getTime() / 1000);
                    let status = "";
                    if (e?.status == "submitted" || e?.status == "pending") {
                      status = e?.status;
                    } else if (e?.status == "ended") {
                      status = "ended";
                    } else if (e?.status == "winner") {
                      status = "winner";
                    } else if (e?.status == "disputed") {
                      status = "disputed";
                    }
                    return (
                      <tr
                        key={id}
                        className={
                          // currentTime > coolDownPeriod &&
                          (e?.status === "winner" &&
                            e?.isClaimed === false && new Date(e?.task?.votingEndPeriod) < new Date())
                            ? " active"
                            : ""
                        }
                      >
                        <td>
                          {" "}
                          <div className="parenttablemain">
                            {
                              // currentTime > coolDownPeriod &&
                              (e?.status === "winner" &&
                                e?.isClaimed === false && new Date(e?.task?.votingEndPeriod) < new Date()) && (
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={renderTooltip}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M18.7304 7.09452C18.7304 7.10312 18.7304 7.11093 18.725 7.11952L16.9531 15.2344C16.8986 15.5201 16.7461 15.7779 16.5219 15.9633C16.2977 16.1487 16.0159 16.2501 15.725 16.25H4.2742C3.98343 16.2499 3.7018 16.1484 3.47778 15.963C3.25376 15.7777 3.10138 15.52 3.04686 15.2344L1.27498 7.11952C1.27498 7.11093 1.27108 7.10312 1.26951 7.09452C1.22102 6.82585 1.26182 6.54869 1.38568 6.30539C1.50954 6.06209 1.70965 5.86603 1.95543 5.74717C2.20121 5.62831 2.47914 5.59319 2.74677 5.64716C3.01439 5.70114 3.25699 5.84125 3.43748 6.04608L6.06795 8.88124L8.86482 2.60858C8.86495 2.60598 8.86495 2.60337 8.86482 2.60077C8.96484 2.38385 9.1249 2.20013 9.32608 2.07136C9.52726 1.94258 9.76112 1.87415 9.99998 1.87415C10.2388 1.87415 10.4727 1.94258 10.6739 2.07136C10.8751 2.20013 11.0351 2.38385 11.1351 2.60077C11.135 2.60337 11.135 2.60598 11.1351 2.60858L13.932 8.88124L16.5625 6.04608C16.7434 5.84277 16.9856 5.70403 17.2525 5.65093C17.5194 5.59784 17.7963 5.63329 18.0413 5.7519C18.2862 5.87051 18.4857 6.06581 18.6095 6.30813C18.7333 6.55045 18.7747 6.82655 18.7273 7.09452H18.7304Z"
                                      fill="#FF9500"
                                    />
                                  </svg>
                                </OverlayTrigger>
                              )}
                          </div>
                        </td>
                        <td>
                          <ConditionalLink to={`/similartaskdetail/${e?.task?.id}`}>
                            <p
                              data-toggle="tooltip"
                              data-placement="top"
                              title={e?.task?.title}
                              className="taskpara"
                            >
                              {e?.task?.title}
                            </p>
                          </ConditionalLink>
                        </td>

                        <td>
                          <p className="tablepara">
                            {e?.task?.reward} {e?.task?.currencySymbol}
                          </p>
                        </td>

                        <td>
                          <a
                            target="_blank"
                            href={`${e?.task?.id > intitial_production_eth_id ? Environment?.trxHashUrl_Arb : Environment?.trxHashUrl}/tx/${e?.task?.taskTransactionHash}`}
                          >
                            {e?.task?.taskTransactionHash?.slice(0, 5) + '....' + e?.task?.taskTransactionHash?.slice(-5)}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                            >
                              <path
                                d="M8.33333 4.66667H6.83333C5.89991 4.66667 5.43285 4.66667 5.07633 4.84832C4.76273 5.00811 4.50795 5.2629 4.34816 5.5765C4.1665 5.93302 4.1665 6.40008 4.1665 7.3335V13.6668C4.1665 14.6003 4.1665 15.0667 4.34816 15.4232C4.50795 15.7368 4.76273 15.9921 5.07633 16.1519C5.43251 16.3333 5.899 16.3333 6.83059 16.3333H13.1691C14.1007 16.3333 14.5665 16.3333 14.9227 16.1519C15.2363 15.9921 15.4919 15.7366 15.6517 15.423C15.8332 15.0668 15.8332 14.6008 15.8332 13.6692V12.1667M16.6665 8V3.83334M16.6665 3.83334H12.4998M16.6665 3.83334L10.8332 9.66667"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </a>
                        </td>
                        {/* <td>
                                                            <p className="tablepara">{currentEpochSeconds1 <= epochSeconds1 ? formattedDuration1 : " CoolDown Period Ended"}</p>
                                                        </td> */}
                        {/* <td>
                                                            {// console.log(currentEpochSeconds1, votingEndPeriodFormated,'currentEpochSeconds1 <= votingEndPeriodFormated')
                                                            }
                                                            <p className="tablepara w-100">{(currentEpochSeconds1 <= epochSecondsVT && e?.task?.status === 'inDispute') ? votingEndPeriodFormated : "Not in voting"}</p>
                                                        </td> */}
                        <td>
                          <div className="creatormain">
                            <div className="creatormainimg">
                              <img
                                src={
                                  e?.task?.user?.imageUrl &&
                                    !e?.task?.user?.imageUrl?.includes("blob")
                                    ? e?.task?.user?.imageUrl
                                    : "/assets/edituploadimg.png"
                                }
                                alt="creatorimg"
                                className="creatorimg"
                              />
                            </div>
                            <p className="creatorwallet">
                              {e?.task?.user?.name
                                ? e?.task?.user?.name
                                : "anonymous"}
                            </p>
                          </div>
                        </td>

                        <td>
                          {/* <TaskStatus status={status} data={e} /> */}
                          {/* <button className='greenbuttontoltip'>Live   <OverlayTrigger
                                                                placement="bottom"
                                                                delay={{ show: 250, hide: 400 }}
                                                                overlay={renderTooltip1}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                    <path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#3EDD1E" />
                                                                </svg>
                                                            </OverlayTrigger> </button> */}
                          <TaskStatus status={status} data={e} />
                          {/* <button className='orangebuttontoltip'>In Dispute Period <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#FF9500" />
                            </svg></button> */}
                          {/* <button className='lightbuttontoltip'>In Voting Period <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#E2C624" />
                            </svg></button> */}
                          {/* <button className='completedtbuttontoltip'>Completed <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#7B808A" />
                            </svg></button> */}
                        </td>
                        <td>
                          {/* <p className="tablepara">{currentEpochSeconds <= epochSeconds && status !== "winner" ? formattedDuration : " time Ended"}</p> */}
                          <ParticipatedTimer
                            status={status}
                            data={e}
                            getProfile={getProfile}
                          />
                        </td>
                        <ClaimRow
                          status={status}
                          data={e}
                          currentEpochSeconds1={currentEpochSeconds1}
                          epochSeconds1={epochSeconds1}
                          apiCallHandler1={apiCallHandler1}
                          apiCallHandler={apiCallHandler}
                        />
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <>
                <>
                  <table>
                    <thead>
                      <th>Task Name</th>
                      <th>Reward</th>
                      <th>Ends in</th>
                      <th>Dispute Period</th>
                      <th>Created By</th>
                      <th>Status</th>
                      <th>Action</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan={7}>
                          {" "}
                          <h6 className="nodata-text">No Data Found!</h6>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              </>
            )}
            <div className="paginationmain">
              {/* <div className="left-f">
          <h6>
                {" "}
                {count > 0 && count <= 5 ? (
                  <>
                    <p>
                      SHOWING 1-{count} OF {count}
                    </p>
                  </>
                ) : count > 5 ? (
                  <>
                    <p>
                      SHOWING {page > 0 ? page * 5 + 1 : page + 1} -
                      {5 * (page + 1) > count ? count : 5 * (page + 1)} OF{" "}
                      {count}
                    </p>
                  </>
                ) : (
                  <>
                    <p>SHOWING 0 OF 0</p>
                  </>
                )}
              </h6>
          </div> */}
              {pages > 1 && (
                <ReactPaginate
                  previousLabel={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M10 13L5 8L10 3"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  nextLabel={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M5 13L10 8L5 3"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName="pagination"
                  activeClassName="active"
                  forcePage={page}
                ></ReactPaginate>
              )}
            </div>
          </div>
          <div className="createdtaskmbl d-none">
            <div className="acctop">
              <p className="taskpara">Task name</p>
              <p className="taskpara">Status</p>
            </div>

            {arry.length > 0 ? (
              <Accordion defaultActiveKey="0">
                {arry.map((e, i) => {


                  const date1 = new Date(e?.task?.coolDownPeriod);
                  const epochSeconds1 = Math.floor(date1.getTime() / 1000);


                  const currentEpochSeconds1 = Math.floor(Date.now() / 1000);

                  // Task Status
                  let status = "";
                  if (e?.status == "submitted" || e?.status == "pending") {
                    status = e?.status;
                  } else if (e?.status == "ended") {
                    status = "ended";
                  } else if (e?.status == "winner") {
                    status = "winner";
                  } else if (e?.status == "disputed") {
                    status = "disputed";
                  }

                  // Current time and cooldown period comparison
                  let currentTime = new Date();
                  let coolDownPeriod = new Date(e?.task?.coolDownPeriod);
                  return (
                    <Accordion.Item eventKey={i}>
                      <Accordion.Header
                        className={
                          currentTime > coolDownPeriod &&
                            e?.status === "winner" &&
                            e?.isClaimed === false
                            ? " active"
                            : ""
                        }
                      >
                        <div className="taskmain">
                          <p
                            className="innertaskpara"
                            data-bs-toggle="tooltip"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={e?.task?.title}
                          >
                            {e?.task?.title?.slice(0, 15)}
                          </p>
                        </div>

                        <div className="statusmain">
                          {/* <span className={status == "submitted" || status == "pending" ? "progressbtn" : status == "ended" ? "endedbtn" : status == "winner" ? "reviewbtn" : "disputedbtn"}>{status}  <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={renderTooltip1}
                            >
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
<path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#4987E4"/>
</svg>
                            </OverlayTrigger></span> */}
                          <TaskStatus status={status} data={e} />
                        </div>

                        {currentTime > coolDownPeriod &&
                          e?.status === "winner" &&
                          e?.isClaimed === false && (
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={renderTooltip}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                className="formobilepictol"
                              >
                                <path
                                  d="M18.7304 7.09452C18.7304 7.10312 18.7304 7.11093 18.725 7.11952L16.9531 15.2344C16.8986 15.5201 16.7461 15.7779 16.5219 15.9633C16.2977 16.1487 16.0159 16.2501 15.725 16.25H4.2742C3.98343 16.2499 3.7018 16.1484 3.47778 15.963C3.25376 15.7777 3.10138 15.52 3.04686 15.2344L1.27498 7.11952C1.27498 7.11093 1.27108 7.10312 1.26951 7.09452C1.22102 6.82585 1.26182 6.54869 1.38568 6.30539C1.50954 6.06209 1.70965 5.86603 1.95543 5.74717C2.20121 5.62831 2.47914 5.59319 2.74677 5.64716C3.01439 5.70114 3.25699 5.84125 3.43748 6.04608L6.06795 8.88124L8.86482 2.60858C8.86495 2.60598 8.86495 2.60337 8.86482 2.60077C8.96484 2.38385 9.1249 2.20013 9.32608 2.07136C9.52726 1.94258 9.76112 1.87415 9.99998 1.87415C10.2388 1.87415 10.4727 1.94258 10.6739 2.07136C10.8751 2.20013 11.0351 2.38385 11.1351 2.60077C11.135 2.60337 11.135 2.60598 11.1351 2.60858L13.932 8.88124L16.5625 6.04608C16.7434 5.84277 16.9856 5.70403 17.2525 5.65093C17.5194 5.59784 17.7963 5.63329 18.0413 5.7519C18.2862 5.87051 18.4857 6.06581 18.6095 6.30813C18.7333 6.55045 18.7747 6.82655 18.7273 7.09452H18.7304Z"
                                  fill="#FF9500"
                                />
                              </svg>
                            </OverlayTrigger>
                          )}
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="mainacc">
                          <div className="inneracc">
                            <p className="leftacc">Ends in</p>
                            <p className="rightacc">
                              {/* {currentEpochSeconds <= epochSeconds &&
                              status !== "winner"
                                ? formattedDuration
                                : " time Ended"} */}
                              <ParticipatedTimer
                                status={status}
                                data={e}
                                getProfile={getProfile}
                              />
                            </p>
                          </div>
                          <div className="inneracc">
                            <p className="leftacc">Reward</p>
                            <p className="rightacc">
                              {e?.task?.reward} {e?.task?.currencySymbol}
                            </p>
                          </div>
                          <div className="inneracc">
                            <p className="leftacc">Transaction Hash</p>
                            <p className="rightacc">
                              <a
                                target="_blank"
                                href={`${e?.id > intitial_production_eth_id ? Environment?.trxHashUrl_Arb : Environment?.trxHashUrl}/tx/${e.task?.taskTransactionHash}`}
                              >
                                {" "}
                                {`${e?.task?.taskTransactionHash?.slice(0, 5)}...${e?.task?.taskTransactionHash?.slice(-3)}`}&nbsp;
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="15"
                                  height="16"
                                  viewBox="0 0 15 16"
                                  fill="none"
                                >
                                  <path
                                    d="M8.75 2.55771H13.125V6.93271M13.125 9.89333V12.8702C13.125 13.1188 13.0262 13.3573 12.8504 13.5331C12.6746 13.7089 12.4361 13.8077 12.1875 13.8077H2.8125C2.56386 13.8077 2.3254 13.7089 2.14959 13.5331C1.97377 13.3573 1.875 13.1188 1.875 12.8702V3.49521C1.875 3.24657 1.97377 3.00811 2.14959 2.8323C2.3254 2.65648 2.56386 2.55771 2.8125 2.55771H5.625M8.0625 7.62021L12.8437 2.83896"
                                    stroke="#627F97"
                                    stroke-width="1.25"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </a>
                            </p>
                          </div>

                          <div className="inneracc">
                            <p className="leftacc">Created By</p>
                            <div className="creatormain">
                              <div className="creatormainimg">
                                <img
                                  src={
                                    e?.task?.user?.imageUrl
                                      ? e?.task?.user?.imageUrl
                                      : "/assets/edituploadimg.png"
                                  }
                                  alt="creatorimg"
                                  className="creatorimg"
                                />
                              </div>
                              <p className="creatorwallet">
                                {e?.task?.user?.name
                                  ? e?.task?.user?.name
                                  : "anonymous"}
                              </p>
                            </div>
                          </div>
                        </div>
                        {/* {((status == 'winner') && (e?.isClaimed == false) && (currentEpochSeconds1 >= epochSeconds1) && (e?.task?.status !== 'inDispute')) ?
                                                        <>
                                                            {e?.task?.disputeWinnerId ?
                                                                <button className="actionbtn" onClick={() => {
                                                                    apiCallHandler1(e)
                                                                }}>Claim reward</button>
                                                                :
                                                                <button className="actionbtn" onClick={() => {
                                                                    apiCallHandler(e)
                                                                }}>Claim reward</button>
                                                            }
                                                        </>
                                                        :
                                                        <button className="diablebtn" >Claim reward</button>
                                                    } */}
                        <ClaimRowMobile
                          status={status}
                          data={e}
                          currentEpochSeconds1={currentEpochSeconds1}
                          epochSeconds1={epochSeconds1}
                          apiCallHandler1={apiCallHandler1}
                          apiCallHandler={apiCallHandler}
                        />

                        {/* <button className='tasksubmit'>Submit Task</button> */}
                        {/* <button className='tasksubmitred'>Create Dispute</button> */}
                        {/* <button className='tasksubmitwithdraw'>Withdraw</button> */}
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            ) : (
              <>
                <h6 className="nodata-text">No Data Found!</h6>
              </>
            )}
            <div className="paginationmain">
              {pages > 1 && (
                <ReactPaginate
                  previousLabel={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M10 13L5 8L10 3"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  nextLabel={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M5 13L10 8L5 3"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName="pagination"
                  activeClassName="active"
                  forcePage={page}
                ></ReactPaginate>
              )}
            </div>
          </div>
        </div>
      </section>

      <Modal
        show={show5}
        onHide={handleClose5}
        className="modal_mainr"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 70 70"
              fill="none"
            >
              <rect
                x="5"
                y="5"
                width="60"
                height="60"
                stroke="#013159"
                stroke-width="2"
              />
              <rect
                x="28.2036"
                y="49.8564"
                width="2"
                height="40.2235"
                transform="rotate(-135 28.2036 49.8564)"
                fill="#013159"
              />
              <rect
                x="17"
                y="38.625"
                width="2"
                height="15.43"
                transform="rotate(-45 17 38.625)"
                fill="#013159"
              />
            </svg>
            <h1>
              {dataaa?.task?.reward} {dataaa?.task?.currency} Successfully
              Withdrawn!
            </h1>
            {/* <p className="parssa">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            <button className="surebutton" onClick={handleClose5}>
              OK
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show4}
        onHide={handleClose4}
        className="modal_mainr"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Claim Reward</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 70 70"
              fill="none"
            >
              <rect
                x="5"
                y="5"
                width="60"
                height="60"
                stroke="#013159"
                stroke-width="2"
              />
              <rect x="34" y="18" width="2" height="28" fill="#013159" />
              <rect x="34" y="49" width="2" height="3" fill="#013159" />
            </svg>
            <h1>
              Are you sure you want to claim <br />
              {winnerData?.task?.reward} {winnerData?.task?.currencySymbol} for
              this task?
            </h1>
            <p className="parssa">
              The reward sum will be transferred to your connected wallet.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            <button className="cancelbutton" onClick={handleClose4}>
              Cancel
            </button>
            <button
              className="surebutton"
              onClick={() => {
                {
                  claimToken();
                }
              }}
            >
              Yes, I’m Sure
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show6}
        onHide={handleClose6}
        className="modal_mainr"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Claim Reward</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              viewBox="0 0 70 70"
              fill="none"
            >
              <rect
                x="5"
                y="5"
                width="60"
                height="60"
                stroke="#013159"
                stroke-width="2"
              />
              <rect x="34" y="18" width="2" height="28" fill="#013159" />
              <rect x="34" y="49" width="2" height="3" fill="#013159" />
            </svg>
            <h1>
              Are you sure you want to claim <br />
              {winnerData?.task?.reward} {winnerData?.task?.currencySymbol} for
              this task?
            </h1>
            <p className="parssa">
              The reward sum will be transferred to your connected wallet.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="modal_footer">
            <button className="cancelbutton" onClick={handleClose6}>
              Cancel
            </button>
            <button
              className="surebutton"
              onClick={() => {
                claimToken1();
              }}
            >
              Yes, I’m Sure
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Taskparticipated;
